import { useMemo } from 'react';

const DEFAULT_OPTIONS = {
  zoom_type: [
    { label: 'magnifier', value: 'magnifier' },
    { label: 'sliders', value: 'sliders' },
    { label: 'in/out buttons', value: 'in/out buttons' },
    { label: 'none', value: '' },
  ],
} as const;

const useImageFormOptions = (options = DEFAULT_OPTIONS) => (
  useMemo(() => ({ ...DEFAULT_OPTIONS, ...options }), [options])
);

export default useImageFormOptions;
